export default "__VITE_ASSET__DEgDWRex__"